import { Component, OnInit, signal } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { OauthService } from '../../../services/oauth.service';
import { ToastService } from '../../../services/toast.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'app-redeem-code',
  imports: [DialogModule],
  templateUrl: './redeem-code.component.html',
  styleUrl: './redeem-code.component.css',
})
export class RedeemCodeComponent implements OnInit {
  redeemDialogVisible: boolean = false;
  isSubmittingAccessCode = signal<boolean>(false);

  constructor(
    private auth: OauthService,
    private toastService: ToastService,
    private http: HttpClient,
    private location: Location,
  ) {}

  ngOnInit() {
    // Clear any access_code URL parameters on component init
    this.clearAccessCodeFromUrl();
    
    this.auth.userSignIn$.subscribe(user => {
      if (user && !user.app_access) {
        this.redeemDialogVisible = true;
      } else {
        this.redeemDialogVisible = false;
      }
    });
  }

  private clearAccessCodeFromUrl(): void {
    const url = new URL(window.location.href);
    if (url.searchParams.has('access_code')) {
      url.searchParams.delete('access_code');
      this.location.replaceState(url.pathname + url.search);
    }
  }

  onAccessCodeSubmit(event: Event, accessCode: string): void {
    event.preventDefault(); // Prevent default form submission behavior
    
    if (!accessCode || !accessCode.trim()) {
      this.toastService.showWarning('Please enter a valid access code');
      return;
    }

    this.isSubmittingAccessCode.set(true);
    const url = `${environment.backendUrl}/db/coupons`;

    this.http.post(url, { code: accessCode.trim() }).subscribe({
      next: async () => {
        this.toastService.showSuccess('Access granted');
        this.isSubmittingAccessCode.set(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
      error: err => {
        this.isSubmittingAccessCode.set(false);
        // Map backend errors to toasts
        if (err?.status === 404) {
          this.toastService.showError('Coupon not found');
        } else if (err?.status === 400) {
          this.toastService.showError(
            err?.error?.detail || 'Coupon already redeemed or invalid'
          );
        } else if (err?.status === 401 || err?.status === 403) {
          this.toastService.showError('You must sign in to redeem a coupon');
        } else {
          this.toastService.showError(
            err?.error?.detail || 'An error occurred while redeeming the coupon'
          );
        }
        console.error('Coupon redeem error');
      },
    });
  }
}
